import http from '../_http_v2';

//wfdetect - wmds -> detect
const forgerydetect = {
  //default
  list: (m) => { return http.post(`console/wmds/forgerydetect/list`, m); },
  detail: (m) => { return http.get(`console/wmds/forgerydetect/${m.id}`); },

  //crud
  update: (m) => { return http.put(`console/wmds/forgerydetect`, m); },
  delete: (m) => { return http.delete(`console/wmds/forgerydetect/${m.id}`); },
}

export default forgerydetect

export { forgerydetect }